module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Clip-acfa28c1f7dbb53b17d3022af0bbed2aaae7ca9b61f05a4dc56e32d83b5d4bca.svg";